    import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/API_Client";
import HoverToDisplayFullTitle from "../../reusableComponents/HoverToDisplayFullTitle";
import { Skeleton, Tooltip, Typography, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
export function AllReportschema(handleDownload, operationPermissions) {
  const { isAuthorizedPermission } = useAuth();
  const schema = {
    metadata: {
      title: "All Reports",
      minHeight: 600,
      position: "relative",
      rowHeight: 60,
      showTitle: false,
    },
    fields: [
      {
        name: "name",
        header: "Report Name",
        visible: true,
        type: "string",
        filtering: true,
        minWidth: 200,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              maxWidth: "200px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.name && (
              <HoverToDisplayFullTitle title={data?.name} len={20} />
            )}
          </div>
        ),
      },
      {
        name: "reportTitle",
        header: "Report Type",
        visible: true,
        type: "string",
        filtering: true,
        minWidth: 240,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <span style={{ display: "flex", marginLeft: "-12px" }}>
            {data.reportTitle}
          </span>
        ),
      },
      {
        name: "addedTimestamp",
        header: "Generated at",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 220,
        defaultFlex: 1,
        textAlign: "start",
        sortable: true,
        render: ({ value }) => (
          <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
        ),
      },
      {
        name: "fromDate",
        header: "Report date timeline",
        visible: true,
        type: "number",
        filtering: false,
        minWidth: 250,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <span style={{ display: "flex", marginLeft: "-12px" }}>
            {data?.fromTimestamp?.split(" ")[0]} <> {data?.fromTimestamp?.split(" ")[0]!==data?.toTimestamp?.split(" ")[0] ? ( '- ' + data?.toTimestamp?.split(" ")[0]) : null}</>
          </span>
        ),
        
      },
      {
        name: "status",
        header: "Status",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 100,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ value,data }) => {
          let backgroundColor;
          let color;
          const status = data?.status;
          const url = data?.downloadLink;
          if (value === "Complete") {
            backgroundColor = "#D5FBD2";
            color = "#0B6A48";
          } else if (value === "Pending") {
            backgroundColor = "#FBEFCB";
            color = "#9E5707";
          } else if (value === "Failed") {
            backgroundColor = "var(--comms-negative-sub, #FDE3D6)";
            color = "var(--comms-negative, #B9232F)";
          } else if (value === "Empty") {
            backgroundColor = "var(--Neutral-4, #F0F0F0)";
            color = "var(--Neutral-9, #434343)";
          }
          return (
            <span
              style={{
                marginLeft: "-20px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                backgroundColor,
                color,
                textTransform:"uppercase"
              }}
            >
              {value}
              <span class="report-tooltip">
               {isAuthorizedPermission(operationPermissions?.downloadReport) && !url &&
               ( <Tooltip
                  title="No records available"
                  sx={{textAlign: "center", fontFamily:"poppins"}}
                >
                  <IconButton
                    sx={{
                      "&:hover": { backgroundColor: "transparent"},
                    }}
                    disableFocusRipple
                    disableTouchRipple
                  >
                    <InfoOutlinedIcon
                      sx={{
                        color: "#0B6A48",
                        width: "14px",
                        height: "14px",
                        order: 1,
                        marginLeft: "2px",
                      }}
                    />
                  </IconButton>
                </Tooltip> ) }
              </span>
            </span>
          );
        },
      },
      {
        name: "downloadLink",
        header: "Actions",
        visible: isAuthorizedPermission(operationPermissions?.downloadReport),
        type: "string",
        filtering: false,
        minWidth: 150,
        defaultFlex: 1,
        textAlign: "center",
        sortable: false,
        render: ({ data }) => {
          const status = data?.status;
          const url = data?.downloadLink;

          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {isAuthorizedPermission(operationPermissions?.downloadReport) &&
              status === "Complete" &&
              url ? (
                <div>
                  <img
                    src="/assets/downloadReport.svg"
                    style={{
                      height: "28px",
                      width: "28px",
                      objectFit: "contain",
                      marginRight: "8px",
                      mixBlendMode: "multiply",
                      marginLeft: "20px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDownload(url)}
                  />
                </div>
              ) : null}
            </span>
          );
        },
      },
    ],
  };

  return schema;
}
